import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { ThemeComponent } from './theme.component';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: ':coalitionId/theme',
      component: ThemeComponent,
      data: { title: 'Theme' },
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ThemeRoutingModule {}
